import React,{useEffect,useRef,useState} from 'react';
import {walletService} from '../api/services';
export default function RequestTopUpReview({transaction,serverOffset=0,onRequested}){
  const [now,setNow]=useState(Date.now()),[busy,setBusy]=useState(false),[error,setError]=useState(''),[requested,setRequested]=useState(false);
  const sending=useRef(false);
  useEffect(()=>{const timer=setInterval(()=>setNow(Date.now()),1000);return()=>clearInterval(timer);},[]);
  const at=Date.parse(transaction.review_available_at||'');
  const remaining=Number.isFinite(at)?Math.max(0,Math.ceil((at-now-serverOffset)/1000)):null;
  const submitted=Boolean(transaction.review_requested_at||requested);
  const request=async()=>{
    if(remaining!==0||submitted||sending.current)return;
    sending.current=true;setBusy(true);setError('');
    try{await walletService.requestTopUpReview(transaction.id);setRequested(true);await onRequested?.();}
    catch(failure){setError(failure.response?.data?.message||'Chưa gửi được yêu cầu duyệt. Vui lòng thử lại.');}
    finally{sending.current=false;setBusy(false);}
  };
  return <div className="topup-review-request">
    {submitted?<span role="status">Đã yêu cầu duyệt tiền</span>:remaining===0?<button type="button" className="btn btn-neutral btn-sm" disabled={busy} onClick={request}>{busy?'Đang gửi…':'Yêu cầu duyệt tiền'}</button>:<small>{remaining===null?'Có thể yêu cầu duyệt sau 5 phút.':`Yêu cầu duyệt sau ${Math.floor(remaining/60)}:${String(remaining%60).padStart(2,'0')}`}</small>}
    {error&&<p role="alert" className="error-message">{error}</p>}
  </div>;
}
